// eslint-disable-next-line kf/no-proptype-import
import PropTypes from "prop-types";

import { userObject } from "./user.js";
import { dynamicObject } from "./dynamic.object.js";

const PROP_TYPES = {
  ...PropTypes,
  userObject,
  dynamicObject
};

export default PROP_TYPES;
